"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = context;
/**
 * Get the context, be it window or global
 */
function context() {
    return ((typeof window !== 'undefined') && window) ||
        ((typeof global !== 'undefined') && global) ||
        this;
}
